var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-self-start"},[_vm._t("label"),_c('RequiredStar')],2)}
var staticRenderFns = []

export { render, staticRenderFns }